export default {"src":"/_next/static/media/delivery.68275fdb.svg","height":42,"width":39};